export enum DashboardAnalyticsEvent {
  InfoBoxLocation = 'DashboardInfoBoxLocation', // Home - klik w fioletowy box lokalizacji nad listą gierek.
  InfoBoxProfile = 'DashboardInfoBoxProfile', // Home - klik w box "Uzupełnij swój profil!", prowadzi do edycji profilu.
  InfoBoxUpdate = 'DashboardInfoBoxUpdate', // Home - klik w box "Dostępna nowa aktualizacja", otwiera sklep.
  InfoBoxUpdateDismiss = 'DashboardInfoBoxUpdateDismiss', // Home - zamknięcie krzyżykiem boxu z aktualizacją.
  InfoBoxRedCardDismiss = 'DashboardInfoBoxRedCardDismiss', // Home - zamknięcie krzyżykiem boxu z czerwoną kartką (box nie jest klikalny).
  GamesAll = 'DashboardGamesAll', // Home - klik w "Wszystkie (N)" nad listą najbliższych gierek.
  EmptyStateFindGames = 'DashboardEmptyStateFindGames', // Home - klik w CTA "Sprawdź dostępne gierki" w pustym stanie.
  EmptyStateCreateGame = 'DashboardEmptyStateCreateGame', // Home - klik w CTA "Stwórz nową gierkę" w pustym stanie.
  InvitationAccept = 'DashboardInvitationAccept', // Home - klik w "Gram!" na zaproszeniu do gierki.
  InvitationDecline = 'DashboardInvitationDecline' // Home - klik w "Nie gram" na zaproszeniu do gierki (przed potwierdzeniem w modalu).
}

export enum ProfileAnalyticsEvent {
  EditProfile = 'ProfileEditProfile', // Profil - klik w "Edytuj profil".
  ChangePassword = 'ProfileChangePassword', // Profil - klik w "Zmień hasło".
  MyGames = 'ProfileMyGames', // Profil - klik w "Moje gry".
  Alerts = 'ProfileAlerts', // Profil - klik w "Alert gierek", prowadzi do ustawień alertów.
  Trophies = 'ProfileTrophies', // Profil - klik w "Moje osiągnięcia".
  CheckUpdate = 'ProfileCheckUpdate', // Profil - klik w "Sprawdź aktualizacje" (tylko natywnie).
  Contact = 'ProfileContact', // Profil - klik w "Napisz do nas".
  Logout = 'ProfileLogout', // Profil - klik w "Wyloguj się" (przed potwierdzeniem w modalu).
  ContactMessageSent = 'ProfileContactMessageSent' // Profil -> Napisz do nas - wysłanie wiadomości.
}

export enum FindGamesAnalyticsEvent {
  ListInfoBoxLocation = 'FindGamesListInfoBoxLocation', // Gierki -> Lista - klik w fioletowy box lokalizacji pod piątą gierką.
  ListFilterLocation = 'FindGamesListFilterLocation', // Gierki -> Lista - klik w "Zlokalizuj się" w pasku filtrów.
  MapBannerLocation = 'FindGamesMapBannerLocation', // Gierki -> Mapa - klik w czerwony baner lokalizacji pod paskiem filtrów.
  MapFilterAlerts = 'FindGamesMapFilterAlerts', // Gierki -> Mapa - klik w "Włącz alerty" / "Edytuj alerty" w pasku filtrów.
  MapPinClick = 'FindGamesMapPinClick', // Gierki -> Mapa - klik w pinezkę gierki (bez pinezki własnej lokalizacji i klików w pustą mapę).
  FiltersChange = 'FindGamesFiltersChange' // Gierki -> Lista i Mapa - zmiana filtra w pasku; `changed` mówi który, reszta to komplet filtrów po zmianie.
}

export type AnalyticsEventSubType = DashboardAnalyticsEvent | FindGamesAnalyticsEvent | ProfileAnalyticsEvent;
